export default "__VITE_ASSET__3MR$OqK0__"